import { useEffect } from "react";

import {
  CtaSection,
  FaqSection,
  Footer,
  Header,
  HeroSection,
  InterfaceSection,
  PricingSection,
  SecuritySection,
  SolutionRowSection,
  TrustSection,
  TrustStatsSection,
} from "@/components/landing";

export const LandingPage = () => {
  // И на html, и на body: для скроллбара окна браузер берёт стили того,
  // с которого всплыла прокрутка
  useEffect(() => {
    const roots = [document.documentElement, document.body];
    roots.forEach((root) => root.classList.add("landing-page"));

    return () => roots.forEach((root) => root.classList.remove("landing-page"));
  }, []);

  return (
    <div className="landing text-landing-ink min-h-screen bg-white font-sans">
      <Header />
      <main>
        <HeroSection />
        <TrustStatsSection />
        <SolutionRowSection />
        <SecuritySection />
        <InterfaceSection />
        <PricingSection />
        <TrustSection />
        <CtaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};
